<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('close')" v-on:input="$emit('close')" max-width="1200px">
    <v-card>
      <v-form v-on:submit.prevent="importar($event)">
        <v-card-title>
          <span class="headline">{{ modal_title }}</span>
        </v-card-title>

        <v-card-text style="min-height: 450px">
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header style="background: #607d8b; color: white">
              <v-stepper-step :complete="step > 1" step="1"> <span class="text-white">Paso 1</span> </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2"> <span class="text-white">Paso 2</span> </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <div class="row justify-content-center">
                  <div class="col-md-5 pt-10">
                    <p class="fs-16">1) Descargue el archivo excel para carga masiva</p>

                    <v-btn color="primary" class="mb-4 text-center ml-4" small @click="downloadTemplate">Descargar</v-btn>

                    <p class="fs-16">2) Complete el excel con los datos de sus productos</p>
                    <p class="fs-16">3) Importe el excel con los datos completos</p>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excel"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>

                    <v-btn color="primary" class="mt-3 float-right" small @click="readExcel" :disabled="excel == null">Siguiente</v-btn>
                  </div>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <div style="border: solid 1px #999">
                  <v-data-table
                    :headers="headers"
                    :items="list_bulk"
                    :search="search"
                    :loading="loading"
                    :options="pagination"
                    loading-text="Cargando... Por favor espere"
                    @pagination="updatePagination"
                    hide-default-footer
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td>{{ item.object.cabecera_num }}</td>
                        <td>{{ item.object.name }}</td>
                        <td>{{ item.object.sku }}</td>
                        <td>{{ item.object.iva_name }}</td>
                        <td>{{ item.object.category_name }}</td>
                        <td>{{ item.object.subcategory_name }}</td>
                        <td>{{ item.object.enabled ? "SI" : "NO" }}</td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                          <i class="fa fa-check text-green"></i>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                          <span class="text-red">{{ item.msg }}</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                          <span class="text-green">Importado</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 0">Pendiente de procesado</td>
                        <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                        <td class="text-center">
                          <font-awesome-icon class="cursor" :icon="expandedRows.includes(index) ? 'chevron-up' : 'chevron-down'" @click="toggleExpand(index)" />
                        </td>
                      </tr>
                      <tr v-if="expandedRows.includes(index)">
                        <td colspan="9" class="pl-0 pr-0">
                          <v-card flat class="grey lighten-4 pa-0">
                            <v-card-text>
                              <div v-if="item.object.presentations_arr && item.object.presentations_arr.length > 0">
                                <v-simple-table dense class="grey lighten-4">
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th>Nombre</th>
                                        <th>Código de Barras</th>
                                        <th>Tipo</th>
                                        <th>U. Almacenamiento</th>
                                        <th>Vendible</th>
                                        <th>Precio Base</th>
                                        <th>Costo</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(pres, idx) in item.object.presentations_arr" :key="idx">
                                        <td>{{ pres.name }}</td>
                                        <td>{{ pres.barcode || "-" }}</td>
                                        <td>{{ pres.presentation_type ? pres.presentation_type.name : "-" }}</td>
                                        <td>{{ pres.storage_unit ? pres.storage_unit.name : "-" }}</td>
                                        <td>{{ pres.sellable ? "SI" : "NO" }}</td>
                                        <td>{{ pres.base_price || "-" }}</td>
                                        <td>{{ pres.cost || "-" }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </div>
                              <div v-else class="text-center pa-3">
                                <span class="grey--text">No tiene presentaciones asociadas</span>
                              </div>
                            </v-card-text>
                          </v-card>
                        </td>
                      </tr>
                    </template>

                    <template v-slot:no-results>
                      <v-alert :value="true" color="error" icon="warning">
                        {{ "Busqueda sin resultados - " + search }}
                      </v-alert>
                    </template>
                  </v-data-table>
                </div>
                <v-btn small class="text-white mt-3 mb-2" @click="step = step - 1" v-if="step != 1" color="red"> Atras </v-btn>

                <div class="pt-0 mt-3">
                  <p style="color: #1976d2; float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Productos pendientes de procesar: {{ getPendienteProcesar() }}</p>
                  <p class="text-green" style="float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Productos procesados validos: {{ getProcesadosValidos() }}</p>
                  <p style="color: red; margin-bottom: 0px; font-size: 16px; margin-bottom: 5px">Productos procesados invalidos: {{ getProcesadosNoValidos() }}</p>
                </div>
                <div class="row mt-1" v-if="loading_create">
                  <div class="col-md-12">
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important">
                      <strong>{{ Math.ceil(percent) }}%</strong>
                    </v-progress-linear>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <!-- START FORM DIALOG -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
          <v-btn v-if="formBtn != ''" text color="green" type="submit" :loading="loading_create" :disabled="list_bulk.length == 0"> Importar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import readXlsxFile from "read-excel-file";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import { productService } from "../../../libs/ws/productService";

export default {
  props: {
    modal_title: String,
    dialog: Boolean,
    service: Object,
    mainItem: Object,
    viewdIndex: Number,
    formBtn: String,
    open: Function,
    close: Function,
    filter: Function,
    create: Function,
  },
  mixins: [ModalGenericMixin, ExportMixin],
  components: {},
  data() {
    return {
      formatUtils: formatUtils,
      step: 1,
      object: null,
      list_bulk: [],
      categories: [],
      subcategories: [],
      headers: [
        {
          text: "Cabecera N°",
          align: "left",
          sortable: true,
          value: "cabecera_num",
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "SKU",
          align: "left",
          sortable: true,
          value: "sku",
        },
        {
          text: "IVA",
          align: "left",
          sortable: true,
          value: "iva_name",
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category_name",
        },
        {
          text: "Subrubro",
          align: "left",
          sortable: true,
          value: "subcategory_name",
        },
        {
          text: "Habilitado",
          align: "left",
          sortable: true,
          value: "enabled",
        },
        { text: "Resultado", value: "msg" },
        { text: "", value: "" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 15,
      },
      search: "",
      loading: false,
      excel: null,
      envios_no_validos: 0,
      envios_creados: 0,
      loading_create: false,
      expandedRows: [],
    };
  },
  computed: {
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },
  watch: {
    dialog() {
      this.errors.clear();
      this.$validator.reset();
      this.excel = null;
      this.loading_create = false;
      this.list_bulk = [];
      this.step = 1;
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    toggleExpand(index) {
      if (this.expandedRows.includes(index)) {
        this.expandedRows = this.expandedRows.filter((rowIndex) => rowIndex !== index);
      } else {
        this.expandedRows.push(index);
      }
    },
    getPendienteProcesar() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 0).length;
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },
    loadComboData() {
      // Cargar categorías
      generalService.setSection(Constant.SECTION_CATEGORIES);
      generalService
        .filter({})
        .then((response) => {
          this.categories = response.result;
        })
        .catch((e) => {
          console.log("categories.filter error", e);
        });

      // Cargar subcategorías
      generalService.setSection(Constant.SECTION_SUBCATEGORIES);
      generalService
        .filter({})
        .then((response) => {
          this.subcategories = response.result;
        })
        .catch((e) => {
          console.log("subcategories.filter error", e);
        });
    },
    parseObject(element) {
      try {
        var object = Object.assign({}, {});
        object.cabecera_num = element[0] != null ? element[0].toString() : null;
        object.name = element[1];
        object.sku = element[2] != null ? element[2].toString() : null;
        object.iva_name = element[3] != null ? element[3].toString() : null;
        object.category_name = element[4];
        object.subcategory_name = element[5];
        object.enabled = element[6] != null ? element[6].toString().toLowerCase() === "si" || element[6].toString() === "1" || element[6] === true : true;
        object.type_name = element[7];
        object.sub_cost_center_name = element[8];

        object.presentations_arr = [];
      } catch (e) {
        console.log(element);
        console.log(e);
      }
      return object;
    },
    readExcel() {
      this.step++;
      this.list_bulk = [];
      this.envios_no_validos = 0;
      this.envios_creados = 0;

      try {
        // Leer hoja 1: Cabecera (Productos)
        readXlsxFile(this.excel, { sheet: 1 }).then((productRows) => {
          const products = [];

          productRows.forEach((element, index) => {
            if (index >= 1) {
              var obj = {
                object: this.parseObject(element),
                msg: "",
                status: 0,
                status_create: false,
                loading: false,
              };
              products.push(obj);
            }
          });

          // Leer hoja 2: Items (Presentaciones)
          readXlsxFile(this.excel, { sheet: 2 })
            .then((presentationRows) => {
              presentationRows.forEach((element, index) => {
                if (index >= 1) {
                  const cabecera_num = element[0] != null ? element[0].toString() : null;

                  // Buscar el producto correspondiente
                  const product = products.find((p) => p.object.cabecera_num === cabecera_num);

                  if (product) {
                    const presentation = {
                      name: element[1],
                      barcode: element[2] != null ? element[2].toString() : null,
                      presentation_type: { name: element[3] },
                      storage_unit: { name: element[4] },
                      composite_presentation: element[5] ? { name: element[5] } : null,
                      amount_composite_presentation: element[6],
                      measure_unit: element[7] ? { name: element[7] } : null,
                      weight_unit: element[8] ? { name: element[8] } : null,
                      weight: element[9],
                      heigth: element[10],
                      width: element[11],
                      length: element[12],
                      sellable: element[13] != null ? element[13].toString().toLowerCase() === "si" || element[13].toString() === "1" || element[13] === true : true,
                      buyable: element[14] != null ? element[14].toString().toLowerCase() === "si" || element[14].toString() === "1" || element[14] === true : true,
                      base_price: element[15],
                      cost: element[16],
                    };

                    product.object.presentations_arr.push(presentation);
                  }
                }
              });

              this.list_bulk = products;
            })
            .catch((error) => {
              console.log("Error leyendo presentaciones:", error);
              // Si no hay hoja 2, usar solo los productos
              this.list_bulk = products;
            });
        });
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrio un error al leer el archivo excel.", "Error");
      }
    },
    async importar() {
      var index = 0;
      this.loading_create = true;
      for (const element of this.list_bulk) {
        //sin mensaje entonces es valido para crear
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = this.parseErrorResultValidation(result);
          if (result.status) {
            this.envios_creados++;
          }
        }

        index++;
      }

      this.loading_create = false;

      if (this.list_bulk.length - this.envios_no_validos == this.envios_creados) {
        this.$toast.success("Se crearon " + this.envios_creados + " productos correctamente.", "Ok");
        this.$emit("close");
        this.$emit("filter");
      } else {
        this.$toast.warning(
          "Se crearon " + this.envios_creados + " productos, pero " + (this.list_bulk.length - this.envios_no_validos - this.envios_creados) + " no se pudieron crear.",
          "Precaucion"
        );
        this.$emit("filter");
      }
    },
    updatePagination(pagination) {
      this.pagination = pagination;
    },
    async createItem(item) {
      return productService.import_line_excel(item);
    },

    downloadTemplate() {
      this.exportExcel("products/get-sample-excel", {}, "plantilla_importacion_productos.xlsx");
    },
  },
};
</script>
